import { configureStore } from '@reduxjs/toolkit';

import { listenerMiddleware } from './listenerMiddleware';
import rootReducer from './reducers';

const initializeStore = () => {
  const newStore = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }).concat(listenerMiddleware.middleware),
  });

  return newStore;
};

export default initializeStore;
